import React from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import ChatOverlay from './components/ChatOverlay';
export function mountChatOverlay(store) {
    const container = document.createElement('div');
    container.id = 'tbl-chat-root';
    document.body.appendChild(container);
    createRoot(container).render(React.createElement(Provider, { store: store },
        React.createElement(ChatOverlay, null)));
}
